import React from 'react';
import { Lesson } from '../../types/interfaces';
import { Card, CardContent, Typography, Box, Grid } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventIcon from '@mui/icons-material/Event';

interface LessonDetailsProps {
  lesson: Lesson;
}

const LessonDetails: React.FC<LessonDetailsProps> = ({ lesson }) => {
  return (
    <Card sx={{ p: 1.5, mb: 2, backgroundColor: '#f9f9f9' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        {/* Lesson Title */}
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#3f51b5', mb: 2 }}>
          {lesson.title}
        </Typography>

        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            {/* Lesson Description */}
            <Box display="flex" alignItems="flex-start" mb={2}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '100px', mr: 2 }}>
                <DescriptionIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Kuvaus:</Typography>
              </Box>
              <Typography variant="body2" sx={{ flex: 1 }}>
                {lesson.description}
              </Typography>
            </Box>

            {/* Lesson Order */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '100px', mr: 2 }}>
                <FormatListNumberedIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Järjestys:</Typography>
              </Box>
              <Typography variant="body2">
                {lesson.order}
              </Typography>
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6}>
            {/* Lesson Status */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '100px', mr: 2 }}>
                <CheckCircleIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Tila:</Typography>
              </Box>
              <Typography variant="body2">
                {lesson.isActive ? 'Aktiivinen' : 'Ei aktiivinen'}
              </Typography>
            </Box>

            {/* Lesson Creation Date */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box display="flex" alignItems="center" sx={{ minWidth: '100px', mr: 2 }}>
                <EventIcon sx={{ mr: 1, color: '#3f51b5' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Luotu:</Typography>
              </Box>
              <Typography variant="body2">
                {new Date(lesson.createdAt).toLocaleDateString()}
              </Typography>
            </Box>

            {/* Lesson Update Date */}
            <Box display="flex" alignItems="center" mb={1}>
              <Box sx={{ minWidth: '100px', mr: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Päivitetty:</Typography>
              </Box>
              <Typography variant="body2">
                {new Date(lesson.updatedAt).toLocaleDateString()}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default LessonDetails;
